module.exports = __webpack_public_path__ + "img/asset16.b51e40a7.svg";